import { useCallback, useMemo, useState } from 'react';
import { useDispatch } from 'react-redux';

import { OnSiteModal } from '@components/OnSiteModal';

export enum SITE_MODE {
  ON = 'on',
  OFF = 'off'
}

export const useOnSiteModal = () => {
  const dispatch = useDispatch();
  const [siteMode, setSiteMode] = useState<SITE_MODE>(SITE_MODE.ON);
  const [visible, setVisible] = useState<boolean>(false)

  const onClose = useCallback(() => {
    setVisible(false)
  }, [dispatch]);

  const displayModal = useCallback(() => {

    setVisible(true)
  }, [])

  console.log('siteMode', siteMode)


  const modalContent = useMemo(() => {
    const children = <OnSiteModal onClose={onClose} setSiteMode={setSiteMode}  siteMode={siteMode}/>;
    return children
    
  }, [dispatch, onClose, setSiteMode, siteMode]);

  

  return { displayModal, siteMode, modalContent: visible ? modalContent : null};
};
